import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/axiosInstance";

export const getAllFaqs = createAsyncThunk(
  "faqs/getAllFaqs",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get("/get-faqs-detail");
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.message?.data || err.message || err || "Something went wrong",
      );
    }
  },
);

export const addQuery = createAsyncThunk(
  "faqs/addQuery",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/add-my-queries", payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.message?.data || err.message || err || "Something went wrong",
      );
    }
  },
);

export const getPastquery = createAsyncThunk(
  "faqs/getPastquery",
  async ({ per_page = 10 } = {}, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get("/get-past-queries", {
        params: { per_page },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err?.response?.data || err.message || "Something went wrong",
      );
    }
  },
);
